(function() {
    'use strict';

    angular.module('swif.reservations')
        .config(router)
        .controller('ReservationRequestController', ReservationRequestController)
        .controller('ReservationActionModal', ReservationActionModal);

    function router($routeProvider) {
        'ngInject';
        $routeProvider.when('/reservations/reservations/table_view', {
            templateUrl: 'partials/openresa/request_table_view.html',
            controller: 'ReservationRequestController',
            reloadOnSearch: false,
            resolve: {
                data: ['openresaRequestService', function(service) {
                    return service.resolveData();
                }]
            }
        });
        $routeProvider.when('/reservations/reservations/explorer_view', {
            templateUrl: 'partials/openresa/request_explorer_view.html',
            controller: 'ReservationRequestController',
            reloadOnSearch: false,
            resolve: {
                data: ['openresaRequestService', function(service) {
                    return service.resolveData();
                }]
            }
        });
    }

    function ReservationRequestController($scope, $location, $q, swif, data, openresa) {
        'ngInject';
        console.log('init ReservationRequestController');
        $scope.modules = swif.module.modules;
        $scope.search = '';
        $scope.currentFilter = {};
        var user = swif.user.getAuthenticatedUserData();
        $scope.is = { manager: _.contains(user.access_rights, 'HOTEL_MANA') };
        $scope.reservationRequests = data.reservationRequests;
        $scope.currentSession = swif.settings.get('token');
        $scope.preModal = openresa.requests.preModal;
        $scope.actionModalsPreValidate = openresa.requests.preValidate;
        $scope.actionsCallback = openresa.requests.callback;

        // for now, collections#getItems() reassign items, so we lose all attached objects
        $scope.$watch('reservationRequests.items', function(newV, oldV) {
            // checking if user is manager or input agent else unauthorized to update, delete, cancel or terminate a booking
            if (newV) {
                $scope.getSumup(newV);
            }
            const unauthorized_user = _.intersection(user.access_rights, ["HOTEL_USER_EXT", "HOTEL_USER_INTERNAL"]);
            for (let i = 0; i < newV.length; i++) {
                if (newV[i].state === 'confirm' && unauthorized_user.length > 0) {
                    newV[i].actions = ["read", "print"];
                }
            }
        });

        $scope.doAction = doAction;
        $scope.doActionRead = doActionRead;
        $scope.getSumup = getSumup;
        $scope.getEventsAndChecks = getEventsAndChecks;
        $scope.getInter = getInter;
        $scope.getKeys = getKeys;
        $scope.attachmentsAction = swif.action.getActionById('reservationRequest', 'meta', 'attachments');

        var settings = swif.settings.app.contentTypes.reservationRequest.actions.misc;
        $scope.showOccurrencesAction = _.find(settings, function(action) {
            return action.id === 'show_occurrences';
        });


        function doAction(request, category, actionId, specificObj, anchor, event) {
            var preModal = function(data) {
                console.log(data)
                var ret = openresa.requests.preModal(data);
                if (specificObj) {
                    data.model._specificObjId = specificObj;
                }
                if (anchor) {
                    data.model._anchor = anchor;
                }
                return ret;
            };
            var callback = function(err, data) {
                var ret = true;
                if (openresa.requests.callback) {
                    ret = openresa.requests.callback(err, data);
                }
                $scope.getSumup([request]);
                return ret;
            };
            var action = swif.action.getActionById('reservationRequest', category, actionId, request);
            var options = {
                preModal: preModal, // attach specificObj id to the model (store the parameter for ctrl)
                preValidate: openresa.requests.preValidate,
                callback: callback
            };
            if (action) {
                swif.action.dispatch('reservationRequest', action, request, options);
            }
            // avoid tr to be de-selected (collection directive)
            if (event) {
                event.stopPropagation();
            }
            return action;
        }

        function doActionRead(request, event) {
            var ret = $scope.doAction(request, 'primary', 'edit');
            if (!swif.action.isAvailable(ret, request)) {
                ret = $scope.doAction(request, 'notWorkflow', 'readonly');
            }
            // avoid tr to be de-selected (collection directive)
            if (event) {
                event.stopPropagation();
            }
            return ret;
        }

        function getSumup(requests) {
            _.forEach(requests, function(request) {
                if (!request.cache) {
                    request.cache = {};
                }
                request.cache.keys = [];
                request.cache.events = [];
                request.cache.checksIn = [];
                request.cache.checksOut = [];
                request.cache.inter = [];
            });
            $scope.getInter(requests);
            $scope.getEventsAndChecks(requests);
        }

        function getEventsAndChecks(requests) {
            var filter = { limit: 0, fields: ['name', 'state', 'request_id', 'is_event', 'enable_checkin', 'enable_checkout', 'checkin_date', 'checkout_date', 'checkin_state', 'checkout_state', 'key_names', 'enable_key_checkin', 'enable_key_checkout', 'key_checkin_date', 'key_checkout_date', 'key_checkin_state', 'key_checkout_state'] };
            swif.data.addFilter(filter, 'state', '!=', 'refuse');
            // swif.data.addFilter(filter, 'is_event', '=', true);
            swif.data.addFilter(filter, 'request_id', 'in', _.pluck(requests, 'id'));
            return swif.data.get('reservation', undefined, filter).then(function(data) {
                _.forEach(data, function(elt) {
                    var request = _.find(requests, { id: elt.request_id[0] });
                    if (request) {
                        if (elt.is_event) {
                            request.cache.events.push(elt);
                        }
                        if (elt.enable_checkin) {
                            request.cache.checksIn.push(elt);
                        }
                        if (elt.enable_checkout) {
                            request.cache.checksOut.push(elt);
                        }
                        if (elt.enable_key_checkin || elt.enable_key_checkout) {
                            request.cache.keys.push(elt);
                        }
                    }
                });
                return requests;
            });
        }

        function getInter(requests) {
            var filter = { limit: 0, fields: ['prestation_id', 'prestation_state', 'ask_id', 'state', 'booking_id'] };
            swif.data.addFilter(filter, 'booking_id.state', '!=', 'refuse');
            swif.data.addFilter(filter, 'booking_id.request_id', 'in', _.pluck(requests, 'id'));
            swif.data.sortOn(filter, 'booking_id', 'ASC');
            return swif.data.get('reservationPrestation', undefined, filter).then(function(data) {
                _.forEach(data, function(elt) {
                    var request = _.find(requests, function(item) {
                        return _.contains(item.booking_ids, elt.booking_id[0]);
                    });
                    if (request) {
                        request.cache.inter.push(elt);
                    }
                });
                return requests;
            });
        }

        function getKeys(request) {
            var ret = $q.defer();
            if (request.cache.expired) {
                var filter = { fields: ['key_id', 'state'] };
                swif.data.addFilter(filter, 'booking_id.state', '!=', 'refuse');
                swif.data.addFilter(filter, 'booking_id.request_id', '=', request.id);
                swif.data.sortOn(filter, 'booking_id', 'ASC');
                swif.data.get('reservationKey', undefined, filter).then(function(data) {
                    request.cache.keys = data;
                    request.cache.expired = false;
                    ret.resolve(request.cache.keys);
                });
            } else {
                ret.resolve(request.cache.keys);
            }
            return ret;
        }

    }

    function ReservationActionModal($scope, $q, swif, openresa, gettextCatalog) {
        'ngInject';
        $scope.currentPage = 1;
        $scope._tasks = [];
        initialize();
        $scope.refuseDate = function(booking) {
            booking._toRefuse = true;
        };
        $scope.undoRefuseDate = function(booking) {
            booking._toRefuse = false;
        };
        $scope.refuseRecurrence = function(recurrence) {
            recurrence._toRefuse = true;
            _.forEach($scope.model.bookings, function(elt) {
                if (elt.recurrence === recurrence) {
                    $scope.refuseDate(elt);
                }
            });
        };
        $scope.undoRefuseRecurrence = function(recurrence) {
            recurrence._toRefuse = false;
            _.forEach($scope.model.bookings, function(elt) {
                if (elt.recurrence === recurrence) {
                    $scope.undoRefuseDate(elt);
                }
            });
        };

        $scope.spreadState = function(recurrence) {
            if (recurrence._occurrencesState) {
                _.forEach($scope.model.bookings, function(elt) {
                    if (elt.recurrence === recurrence) {
                        elt.state = recurrence._occurrencesState;
                    }
                });
            }
        };

        function prepareConfirmAction(model) {
            _.forEach(model.bookings, function(booking) {
                if (booking.state === 'waiting') {
                    booking.state = 'active';
                }
            });
            _.forEach($scope.model.recurrences, function(recurrence) {
                if (!recurrence._occurrencesState) {
                    recurrence._occurrencesState = 'active';
                }
            });
        }

        function prepareButtons() {
            $scope.model.displaySendMail = true;
            $scope.model.displayNote = true;
            $scope.model.displaySendInvoice = false;

            switch ($scope.action.id) {
                case 'submit':
                    $scope.model.displaySendMail = false;
                    $scope.model.displayNote = false;
                    break;
                case 'confirm':
                    $scope.model.displaySendInvoice = true;
                    $scope.model.displayRefuseBtn = true;
                    break;
                case 'done':
                    $scope.model.displaySendInvoice = true;
                    break;
                case 'readonly':
                    $scope.model._readonly = true;
                    break;
            }
        }

        function resourcesToLines(model) {
            model.lines = [];
            _.forEach(model.resources, function(resource) {
                var line = angular.copy(resource);
                line.resource = resource;
                line.product_id = [resource.id, resource.name];
                line._type = 'dummy';
                line.id = resource.booking_line_id;
                model.lines.push(line);
            });
            openresa.bookables._computeLineAvailability(model);
            return model;
        }

        $scope.fillAutomaticTask = function(resource) {
            if ($scope.model._tasks === undefined) {
                $scope.model._tasks = [];
            }

            _.forEach($scope.model.bookings, function(booking) {
                _.forEach(booking.lines, function(line) {
                    if (resource.id === line.resource.id) {

                        // verify if the task_category was already selected and the task "pre-created"
                        var index = $scope.model._tasks.findIndex(task => {
                            return task._resId === resource.id && task.date_start == booking.checkin;
                        });

                        if (!resource.task_category[0]) {
                            // in case task category was selected, then the user unselect it, we have to remove the task.
                            if (index !== -1) {
                                $scope.model._tasks.splice(index, 1);
                                resource.helpText = gettextCatalog.getString('If left blank, no task is created for') + ' ' + resource.partialHelpText;
                            }
                        } else {
                            if (index === -1) {
                                var task = {};
                                task._resId = resource.id;
                                task.name = `[R.${$scope.model.id}] ${$scope.model.name}`;
                                task.date_start = booking.checkin;
                                task.date_end = booking.checkout;
                                task.report_hours = moment(task.date_end).diff(task.date_start, 'h', true);
                                task.category_id = resource.task_category[0];
                                switch (resource.resource_model) {
                                    case 'res.users':
                                        task.user_id = resource.resource_id;
                                        task.service_id = resource.resource_service_id;
                                        break;
                                    case 'openstc.team':
                                        task.team_id = resource.resource_id;
                                        break;
                                    case 'res.partner':
                                        task.partner_id = resource.resource_id;
                                        break;
                                    default:
                                }
                                // get all lines ids to fetch their site or equipment ids (separated call to lighten generic search_read)
                                var line_ids = [];
                                _.forEach(booking.lines, function(line) {
                                    line_ids.push(line.id);
                                });
                                swif.data.callKw(
                                    'reservation_line',
                                    'get_site_or_equipment_id', [line_ids]
                                ).then(function(site_or_eq_ids) {
                                    _.forEach(site_or_eq_ids, function(res_id) {
                                        if (res_id.site_id) {
                                            task.site1 = res_id.site_id;
                                        }
                                        if (res_id.equipment_id) {
                                            task.equipment_id = res_id.equipment_id;
                                        }
                                    });
                                });

                                $scope.model._tasks.push(task);
                                resource.helpText = gettextCatalog.getString('At closure, a task will be created for') + ' ' + resource.partialHelpText;
                            } else {
                                $scope.model._tasks[index].category_id = resource.task_category[0];
                            }
                        }
                    }
                });
            });
        }

        $scope.resourcesFilters = {};
        _.forEach($scope.model.resources, function(resource) {
            var filter = {};
            swif.data.addFilter(filter, '|');
            swif.data.addFilter(filter, 'service_ids', '=', false);
            switch (resource.type_prod) {
                case 'user':
                    swif.data.addFilter(filter, 'service_ids', 'in', [resource.resource_service_id]);
                    break;
                case 'team':
                    swif.data.addFilter(filter, 'service_ids', 'in', [resource.resource_service_id]);
                    break;
                case 'organization':
                    swif.data.addFilter(filter, 'service_ids', 'in', [resource.resource_service_id]);
                    break;
                default:
                    swif.data.addFilter(filter, 'service_ids', '=', false);
            }
            $scope.resourcesFilters[resource.id] = filter;
        });

        function prepareTaskCreation() {
            $scope.hasOpenstcModule = swif.module.modules.openstc;
            $scope.hasTasksToCreate = false;
            if ($scope.model.state === 'confirm') {
                _.forEach($scope.model.resources, function(resource) {
                    if (['user', 'team', 'organization'].includes(resource.type_prod)) {
                        $scope.hasTasksToCreate = true
                    }
                    switch (resource.type_prod) {
                        case 'user':
                            resource.partialHelpText = gettextCatalog.getString('the agent.');
                            break;
                        case 'team':
                            resource.partialHelpText = gettextCatalog.getString('the team.');
                            break;
                        case 'organization':
                            resource.partialHelpText = gettextCatalog.getString('the organization.');
                            break;
                    }
                    resource.helpText = gettextCatalog.getString('If left blank, no task is created for') + ' ' + resource.partialHelpText;
                });
            }
        }

        function initialize() {
            $scope.model = openresa.requests.init($scope.model);
            openresa.requests.fetch($scope.model).then(function() {
                openresa.requests.linkRecurrenteBookings($scope.model);
                openresa.requests.fetchSlowFields($scope.model, { fields: ['resources'] })
                    .then(function() {
                        $scope.model.recurrences = _.map(
                            $scope.model.recurrences,
                            resourcesToLines
                        );
                        $scope.model.bookings = _.map(
                            $scope.model.bookings,
                            resourcesToLines
                        );
                    });
                prepareTaskCreation();
                prepareButtons();
                if ($scope.action.id === 'confirm') {
                    prepareConfirmAction($scope.model);
                }
            });
        }
    }
})();